<template>
	<div v-if="params.value" class="flex items-center">
		<vs-avatar :src="params.data.profile_pic" class="flex-shrink-0 mr-2" size="24px" />
		<div>{{ params.value }}</div>
	</div>
</template>

<script>
	export default {
		name: 'CellRendererLink',
	}
</script>
